import { getJrnDefaultComponent } from '../getJrn/getJrnDefaultComponent.js'
import getRegistrationProxyController from './getRegistrationProxyController.js'
import _module from 'module.js'
import _ from 'lodash'

let getRegistrationProxyComponent = _.cloneDeep(getJrnDefaultComponent)
getRegistrationProxyComponent.controller = getRegistrationProxyController

_module.component('getRegistrationProxy', getRegistrationProxyComponent)
